export const serviceList = [
  { name: "technology", title: "Technology" },
  { name: "digital_marketing", title: "Digital Marketing" },
  { name: "contect_marketing", title: "Contect Marketing" },
];

export const Services = {
  technology: [
    {
      name: "Web Development",
      value: "web",
    },
    {
      name: "Mobile Development",
      value: "mobile",
    },
    {
      name: "UI/UX Design",
      value: "ui",
    },
    {
      name: "CRM",
      value: "crm",
    },
  ],
  digital_marketing: [
    {
      name: "Social Media",
      value: "social_media",
    },
    {
      name: "Content Strategy",
      value: "content_strategy",
    },
  ],
  contect_marketing: [
    {
      name: "Graphic Design",
      value: "graphic",
    },
    {
      name: "Copywritig",
      value: "copywritig",
    },
    {
      name: "Animation",
      value: "animation",
    },
    {
      name: "Video Production",
      value: "video_production",
    },
  ],
};

export const ServicesList = {
  technology: [
    {
      name: "Web Development",
      slug: "web",
      discription:
        "Our expert web developers, are known for constructing efficient and sustainable applications by using new technologies to build user-centric interfaces.",
    },
    {
      name: "Mobile Development",
      slug: "mobile",
      discription:
        "We create next-gen mobile apps that are quality-tested to perfection! Using the latest technology stack that helps generate high revenue for your business.",
    },
    {
      name: "UI/UX Design",
      slug: "ui",
      discription:
        "Our UI Designers transform dreams into best-in-class aesthetic designs that ensure user returns by enhancing user interactions.",
    },
    {
      name: "CRM",
      slug: "crm",
      discription:
        "We build custom websites for your company based on your customers’ needs, adding value to their experience & distinguishing your business from others.",
    },
  ],
  digital_marketing: [
    {
      name: "Social Media",
      slug: "social",
      discription:
        "Our experts leverage social media platforms to engage your target audience, build brand awareness, and drive conversions.",
    },
    {
      name: "Content Strategy",
      slug: "content",
      discription:
        "We develop high-quality, relevant content that establishes your authority in your industry and attracts potential customers.",
    },
  ],
  contect_marketing: [
    {
      name: "Graphic Design",
      slug: "graphic",
      discription:
        "We build custom websites for your company based on your customers’ needs, adding value to their experience & distinguishing your business from others.",
    },
    {
      name: "Copywriting",
      slug: "copy",
      discription:
        "We build custom websites for your company based on your customers’ needs, adding value to their experience & distinguishing your business from others.",
    },
    {
      name: "Animation",
      slug: "animation",
      discription:
        "We build custom websites for your company based on your customers’ needs, adding value to their experience & distinguishing your business from others.",
    },
    {
      name: "Video Production",
      slug: "video",
      discription:
        "We build custom websites for your company based on your customers’ needs, adding value to their experience & distinguishing your business from others.",
    },
  ],
};

export const workheaderData = [
  {
    name: "All",
  },
  {
    name: "Graphic",
  },
  {
    name: "Mobile",
  },
  {
    name: "Web",
  },
];

export const workSample = [
  {
    category: "Graphic",
    name: "Mielo India",
    slug: "Mielo_India",
    img: require("../assets/img/mielo.jpeg"),
  },
  {
    category: "Mobile",
    name: "Events 360",
    slug: "Event_360",
    img: require("../assets/img/event_360s.jpeg"),
  },
  // {
  //   category: "Graphic",
  //   name: "Go Dady",
  //   slug: "general",
  //   img: null,
  // },
];

export const videosFilter = [
  {
    name: "ALL",
    value: "all",
  },
  {
    name: "LOGO ANIMATION",
    value: "logo animation",
  },
  {
    name: "WEB ANIMATION",
    value: "web animation",
  },
  {
    name: "MOBILE APP ANIMATION",
    value: "mobile app animation",
  },
  {
    name: "STICKER PACK",
    value: "sticker pack",
  },
  {
    name: "RIVE APP ANIMATION",
    value: "rive app animation",
  },
];

export const logoVideos = [
  {
    name: "Mada",
    src: require("../assets/gif/Madad V2.gif"),
    category: "logo animation",
  },
  {
    name: "Honeycomb",
    src: require("../assets/gif/Honeycomb.gif"),
    category: "logo animation",
  },
  {
    name: "Publish Hub",
    src: require("../assets/gif/Publish hub 1.gif"),
    category: "logo animation",
  },
  {
    name: "Pskyee",
    src: require("../assets/gif/Psykee_1.gif"),
    category: "logo animation",
  },
  {
    name: "Play Gate",
    src: require("../assets/gif/Playgate.gif"),
    category: "logo animation",
  },
  {
    name: "Value Bet",
    src: require("../assets/gif/Vakye_Bet.gif"),
    category: "logo animation",
  },
  {
    name: "Stoberry Cack",
    src: require("../assets/gif/main_composition.gif"),
    category: "web animation",
  },
];
